export default __webpack_public_path__ + "static/media/LightBlue0001.915cd6ce.png";